export var partnerData = function() {
    return [
        {
            "id": "1",
            "partnerCode": "SK12653",
            "vendorCode": "",
            "dateSend": "2025-02-24",
            "nameCompany": "ธุรกิจ แป้งดีดี จำกัด",
            "taxCode": "165875548755",
            "typeCompany": "นิติบุคคล",
            "qty": "",
            "statusId": "1",
            "statusName": "รออนุมัติ",
            "note": ""
        },
        {
            "id": "2",
            "partnerCode": "SK12654",
            "vendorCode": "VD-0015",
            "dateSend": "2025-02-24",
            "nameCompany": "ธุรกิจ ลิปสวย จำกัด",
            "taxCode": "1658755487550",
            "typeCompany": "นิติบุคคล",
            "qty": "10",
            "statusId": "2",
            "statusName": "อนุมัติแล้ว",
            "note": ""
        },
        {
            "id": "3",
            "partnerCode": "SK12655",
            "vendorCode": "",
            "dateSend": "2025-02-24",
            "nameCompany": "ธุรกิจ ผมสวย จำกัด",
            "taxCode": "1658755487660",
            "typeCompany": "นิติบุคคล",
            "qty": "10",
            "statusId": "3",
            "statusName": "ยกเลิก",
            "note": ""
        },
        {
            "id": "4",
            "partnerCode": "SK12656",
            "vendorCode": "",
            "dateSend": "2025-02-24",
            "nameCompany": "ธุรกิจ ตาสวย จำกัด",
            "taxCode": "1658755487670",
            "typeCompany": "นิติบุคคล",
            "qty": "5",
            "statusId": "4",
            "statusName": "รอแก้ไข",
            "note": "กรุณาแก้ไขข้อมูลที่ตั้งบริษัทใหม่ด้วยครับ เนื่องด้วยชื่อตำบลไม่ถูกต้อง"
        }
    ];
};
var productDetailData = function() {
    return [
        {
            "id": "1",
            "productId": "1",
            "productCode": "-",
            "productBarcode": "8854815084858",
            "productFeature": "-",
            "productUnit": "แท่ง",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "2",
            "productId": "1",
            "productCode": "-",
            "productBarcode": "8854815084859",
            "productFeature": "-",
            "productUnit": "กล่อง",
            "productRatio": "1x10",
            "productPrePrice": "550.00",
            "productRecPrice": "750.00",
            "productGp": "36.7 %"
        },
        {
            "id": "3",
            "productId": "1",
            "productCode": "-",
            "productBarcode": "8854815084880",
            "productFeature": "-",
            "productUnit": "ลัง",
            "productRatio": "1x100",
            "productPrePrice": "5000.00",
            "productRecPrice": "7000.00",
            "productGp": "36.7 %"
        }
    ];
};
var productDetailData2 = function() {
    return [
        {
            "id": "4",
            "productId": "2",
            "productCode": "SSK1-01",
            "productBarcode": "-",
            "productFeature": "แดง / เล็ก",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "5",
            "productId": "2",
            "productCode": "SSK1-02",
            "productBarcode": "-",
            "productFeature": "แดง / กลาง",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "6",
            "productId": "2",
            "productCode": "SSK1-03",
            "productBarcode": "-",
            "productFeature": "แดง / ใหญ่",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "7",
            "productId": "2",
            "productCode": "SSK1-04",
            "productBarcode": "-",
            "productFeature": "แดง / จัมโบ้",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "109.00",
            "productGp": "50.0 %"
        },
        {
            "id": "8",
            "productId": "2",
            "productCode": "SSK1-05",
            "productBarcode": "-",
            "productFeature": "ดำ / เล็ก",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "9",
            "productId": "2",
            "productCode": "SSK1-06",
            "productBarcode": "-",
            "productFeature": "ดำ / กลาง",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "10",
            "productId": "2",
            "productCode": "SSK1-07",
            "productBarcode": "-",
            "productFeature": "ดำ / ใหญ่",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "79.00",
            "productGp": "36.7 %"
        },
        {
            "id": "11",
            "productId": "2",
            "productCode": "SSK1-08",
            "productBarcode": "-",
            "productFeature": "ดำ / จัมโบ้",
            "productUnit": "ตัว",
            "productRatio": "1x1",
            "productPrePrice": "59.00",
            "productRecPrice": "109.00",
            "productGp": "50.0 %"
        }
    ];
};
export var productRowData = function() {
    return [
        {
            "id": "1",
            "code": "SK12653",
            "name": "ลิป เบอร์ 3",
            "subName": "8854815084858",
            "image": "",
            "prePrice": "3440.00",
            "price": "3440.00",
            "dateApprove": "24/02/2024",
            "dateContract": "-",
            "dateExpiry": "-",
            "qty": "3",
            "statusId": "1",
            "statusName": "รอทำสัญญา",
            "datail": productDetailData()
        },
        {
            "id": "2",
            "code": "SK1",
            "name": "ลิป เบอร์ 3",
            "subName": "8854815084858",
            "image": "",
            "prePrice": "3440.00",
            "price": "3440.00",
            "dateApprove": "24/02/2024",
            "dateContract": "24/02/2024",
            "dateExpiry": "24/02/2025",
            "qty": "8",
            "statusId": "2",
            "statusName": "ทำสัญญาแล้ว",
            "datail": productDetailData2()
        }
    ];
};
export var historyRowData = function() {
    return [
        {
            "id": "1",
            "sendDate": "17/04/2025 11:35:16",
            "partnerId": "1",
            "partnerName": "นงลักษณ์ เมืองวงศ์",
            "adminId": "",
            "adminName": "",
            "remark": "ได้ทำการแก้ไขข้อมูลที่ตั้งบริษัทใหม่"
        },
        {
            "id": "2",
            "sendDate": "10/04/2025 10:30:16",
            "partnerId": "",
            "partnerName": "",
            "adminId": "30",
            "adminName": "Admin คนที่1",
            "remark": "รายละเอียดข้อมูลที่ตั้งบริษัทไม่ครบถ้วน"
        },
        {
            "id": "3",
            "sendDate": "9/04/2025 11:35:16",
            "partnerId": "1",
            "partnerName": "นงลักษณ์ เมืองวงศ์",
            "adminId": "",
            "adminName": "",
            "remark": "ยืนเรื่องขออนุมัติการเป็นคู่ค้า"
        }
    ];
};
